<div class="grid" *ngIf="isLoading">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{ 'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div [hidden]="isLoading">
  <div class="grid">
    <div class="col-12 md:col-2 lg:col-2">
      <div class="pasarela-methods">
        <span class="pasarela-methods-title">{{ 'PRODUCTO_PASARELA.LBL_TIPO_METODO' | translate }}</span>
        <ul class="pasarela-methods-list">
          <li
            *ngFor="let method of methods"
            (click)="onSelectMethod(method)"
            [class.pasarela-method-active]="selectedMethod?.idMetodoLista === method.idLista"
            class="pasarela-method-item">
            {{ method.nombre }}
          </li>
        </ul>
      </div>
    </div>

    <div class="col-12 md:col-10 lg:col-10">
      <div [hidden]="selectedMethod">
        <div class="col-12 md:col-3 lg:col-3 pl-0 mb-2">
          <span class="new-input-icon">
            <i class="pi pi-search"></i>
            <input
              type="text"
              pInputText
              class="new-input"
              placeholder="{{ 'LBL_BUSCAR' | translate }}"
              (input)="dt.filterGlobal($any($event.target).value, 'contains')">
          </span>
        </div>

        <div class="border-round overflow-hidden">
          <p-table
            #dt
            [columns]="cols"
            [value]="records"
            [loading]="isLoading"
            [paginator]="true"
            [rows]="rows"
            responsiveLayout="scroll"
            styleClass="p-datatable-sm table-premium">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sort">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.codigoMetodoLista }}</td>
                <td>{{ row.nombreMetodoLista }}</td>
                <td>
                  <p-button
                    *ngIf="!isDetail"
                    icon="fa fa-pencil"
                    (onClick)="edit(row)"
                    type="button"
                    styleClass="btn-action-premium"
                    data-toggle="tooltip"
                    [title]="'BTN_EDITAR' | translate">
                  </p-button>
                  <p-button
                    icon="fa fa-eye"
                    (onClick)="view(row)"
                    type="button"
                    styleClass="btn-action-premium ml-2"
                    data-toggle="tooltip"
                    [title]="'BTN_VISUALIZAR' | translate">
                  </p-button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns?.length || 1" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <ng-container *ngIf="selectedMethod">
        <form [formGroup]="form" novalidate class="mb-3">
          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form gap-2" style="display: grid; grid-template-columns: auto 1fr; align-items: center;">
                <label class="white-space-nowrap flex-shrink-0">* {{ 'PRODUCTO_PASARELA.LBL_TARIFA_GENERAL' | translate }}</label>
                <input
                  pInputText
                  type="text"
                  autocomplete="off"
                  placeholder="{{ 'LBL_INGRESAR' | translate }}"
                  id="tarifaGeneral"
                  name="tarifaGeneral"
                  formControlName="tarifaGeneral"
                  number-format-reactive
                  [prefix]="appSettingService.simboloDinero + ' '"
                  [maxIntegerDigits]="12"
                  [maxDecimalDigits]="3">
                <div class="p-message p-messages-error p-corner-all" style="grid-column: 2;" *ngIf="submitted && f.tarifaGeneral.invalid">
                  {{ 'PRODUCTO_PASARELA.LBL_TARIFA_GENERAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form gap-2" style="display: grid; grid-template-columns: auto 1fr; align-items: center;">
                <p-checkbox
                  label="{{ 'PRODUCTO_PASARELA.LBL_APLICA_IVA' | translate }}"
                  [binary]="true"
                  formControlName="indicadorAplicaIva">
                </p-checkbox>
                <ng-container *ngIf="f.indicadorAplicaIva.value">
                  <input
                    pInputText
                    type="text"
                    autocomplete="off"
                    id="valorIva"
                    name="valorIva"
                    formControlName="valorIva"
                    number-format-reactive
                    [suffix]="' ' + appSettingService.percentageSymbol"
                    [maxIntegerDigits]="3"
                    [maxDecimalDigits]="3">
                  <div class="p-message p-messages-error p-corner-all" style="grid-column: 2;" *ngIf="submitted && f.valorIva.invalid">
                    {{ 'PRODUCTO_PASARELA.LBL_VALOR_IVA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox
                label="{{ 'PRODUCTO_PASARELA.LBL_APLICA_TASA_PREFERENCIAL' | translate }}"
                [binary]="true"
                formControlName="indicadorAplicaTasaPreferencial">
              </p-checkbox>
            </div>
            <div *ngIf="isDetail && isNewRecord" class="col-12 col p-messages p-messages-info p-corner-all p-2 mb-2">
              {{ 'PRODUCTO_PASARELA.MSG_METODO_NO_CONFIGURADO' | translate }}
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12 gap-3">
              <button
                *ngIf="form.enabled"
                type="button"
                class="new-btn-cancel shadow-none"
                pButton
                label="{{ 'BTN_CANCELAR' | translate }}"
                (click)="onCancel()"
                [loading]="saving">
              </button>
              <button
                *ngIf="form.disabled"
                type="button"
                pButton
                icon="fa fa-arrow-left"
                label="{{ 'BTN_REGRESAR' | translate }}"
                (click)="onCancel()">
              </button>
              <button
                *ngIf="form.enabled"
                pButton
                type="submit"
                class="shadow-none"
                icon="pi pi-save"
                label="{{( isNewRecord ? 'BTN_GUARDAR' : 'BTN_ACTUALIZAR')  | translate }}"
                (click)="onSubmit()"
                [loading]="saving">
              </button>
            </div>
          </div>
        </form>

        <p-accordion [multiple]="false" [(activeIndex)]="accordionActiveIndex">
          <p-accordionTab [cache]="false" [disabled]="isNewRecord" headerStyleClass="text-xs font-semibold" header="{{ 'PRODUCTO_PASARELA_TARIFAS.LBL_TITULO' | translate | uppercase }}">
            <ng-template pTemplate="content">
              <app-producto-pasarela-tarifas #tarifasComponent [isDetail]="form.disabled" [productoPasarela]="selectedMethod"></app-producto-pasarela-tarifas>
            </ng-template>
          </p-accordionTab>
          <p-accordionTab [cache]="false" [disabled]="isNewRecord" headerStyleClass="text-xs font-semibold" header="{{ 'PRODUCTO_PASARELA_CONTRATO.LBL_TITULO' | translate | uppercase }}">
            <ng-template pTemplate="content">
              <app-producto-pasarela-contratos #contratosComponent [isDetail]="form.disabled" [productoPasarela]="selectedMethod"></app-producto-pasarela-contratos>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
      </ng-container>
    </div>
  </div>
</div>

<p-confirmDialog #cd [key]="cdKey">
  <ng-template pTemplate="footer">
    <button type="button" pButton class="btn-primary-outline" label="{{ 'BTN_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton class="btn-primary-full" icon="fa fa-sign-out" label="{{ 'BTN_SI_SALIR' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
